import { Outlet } from 'react-router';
import AnnouncementBar from './AnnouncementBar';
import Navbar from './Navbar';
import Footer from './Footer';

export default function Layout({
  children,
  showFooter = true,
  removeContainer = false,
  flushBelowNavbar = false,
}: {
  children: React.ReactNode;
  showFooter?: boolean;
  removeContainer?: boolean;
  flushBelowNavbar?: boolean;
}) {
  return (
    <div className="flex min-h-screen flex-col">
      {/* <AnnouncementBar /> */}
      <Navbar />
      <main
        className={`${removeContainer ? '' : 'container mx-auto px-10'} flex-1 ${
          flushBelowNavbar ? 'pt-20' : 'py-6 pt-32 md:pt-20'
        }`}
      >
        {children}
      </main>
      {showFooter && <Footer />}
    </div>
  );
}
